import React, { createContext } from "react";

export const VMContext = createContext();

export const VMContextProvider = ({ children }) => {
  var [QuerySetReleadCounter, setQuerySetReleadCounter] = React.useState(0);
  var [currentRealeasingSetId, setCurrentRealeasingSetId] =
    React.useState(null);

  return (
    <VMContext.Provider
      value={{
        QuerySetReleadCounter,
        setQuerySetReleadCounter,
        currentRealeasingSetId,
        setCurrentRealeasingSetId,
      }}
    >
      {children}
    </VMContext.Provider>
  );
};
